export default __webpack_public_path__ + "font/roboto-v20-latin-ext_latin-regular.woff2";